import { Accordion } from '@delmonicos/shared-design-system-react/src/components/accordion/accordion';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MiniTitle } from '@delmonicos/shared-design-system-react/src/components/typography/mini-title/mini-title';
import {
  Text,
  TextColor,
  TextFontSize,
  TextWeight,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEmspBoEmspUserContext } from '../emsp-bo-emsp-user.context';

export const EmspBoEmspUserAuthenticatorListController =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { authenticators } = useEmspBoEmspUserContext();

    // RENDER //////////////////////////////////////////////////////////////////

    const hasAny =
      authenticators.email.length > 0 || authenticators.webauthn.length > 0;

    return (
      <Card direction="column" gap={GapEnum.L}>
        <Stack alignItems="center" gap={GapEnum.XS}>
          <AccentTitle
            icon="lock-01"
            text={t('delmonicos-shared-sdk.outputs-emsp-user.authenticators')}
          />
        </Stack>
        {!hasAny && (
          <Text color={TextColor.Secondary}>
            {t('$.emsp-bo-emsp-user-authenticator-list.empty')}
          </Text>
        )}
        {authenticators.email.length > 0 && (
          <Stack direction="column" gap={GapEnum.M}>
            <Text
              fontSize={TextFontSize.Small}
              fontWeight={TextWeight.SemiBold}
              color={TextColor.Secondary}>
              {t(
                'delmonicos-shared-sdk.outputs-emsp-user-authenticators.email',
              )}
            </Text>
            {authenticators.email.map((authenticator) => (
              <Accordion
                key={authenticator.id}
                title={authenticator.emailAddress}
                isOpen={false}>
                <Stack direction="column" gap={GapEnum.XS}>
                  <Stack direction="column" gap={GapEnum.XS}>
                    <MiniTitle>
                      {t(
                        'delmonicos-shared-sdk.outputs-emsp-user.email-address',
                      )}
                    </MiniTitle>
                    <Text>{authenticator.emailAddress}</Text>
                  </Stack>
                  <Stack direction="column" gap={GapEnum.XS}>
                    <MiniTitle>
                      {t(
                        'delmonicos-shared-sdk.outputs-emsp-user.is-email-address-verified',
                      )}
                    </MiniTitle>
                    <Stack alignItems="center" gap={GapEnum.XS}>
                      {authenticator.isVerified ? (
                        <Icon name="check-circle" color={IconColor.Success} />
                      ) : (
                        <Icon name="x-circle" color={IconColor.Error} />
                      )}
                    </Stack>
                  </Stack>
                  <Divider />
                </Stack>
              </Accordion>
            ))}
          </Stack>
        )}
        {authenticators.webauthn.length > 0 && (
          <Stack direction="column" gap={GapEnum.M}>
            <Text
              fontSize={TextFontSize.Small}
              fontWeight={TextWeight.SemiBold}
              color={TextColor.Secondary}>
              {t(
                'delmonicos-shared-sdk.outputs-emsp-user-authenticators.webauthn',
              )}
            </Text>
            {authenticators.webauthn.map((authenticator) => (
              <Accordion
                key={authenticator.id}
                title={authenticator.credentialId}
                isOpen={false}>
                <Stack direction="column" gap={GapEnum.XS}>
                  {authenticator.name && (
                    <Stack direction="column" gap={GapEnum.XS}>
                      <MiniTitle>
                        {t(
                          'delmonicos-shared-sdk.outputs-emsp-user-web-authn-authenticator.name',
                        )}
                      </MiniTitle>
                      <Text>{authenticator.name}</Text>
                    </Stack>
                  )}
                  <Stack direction="column" gap={GapEnum.XS}>
                    <MiniTitle>
                      {t(
                        'delmonicos-shared-sdk.outputs-emsp-user-web-authn-authenticator.credential-id',
                      )}
                    </MiniTitle>
                    <Text>{authenticator.credentialId}</Text>
                  </Stack>
                  <Divider />
                </Stack>
              </Accordion>
            ))}
          </Stack>
        )}
      </Card>
    );
  };
